import { Backdrop, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Typography } from '@mui/material';
import React, { Fragment, memo, useEffect, useRef, useState } from 'react';
import { Br, Cut, Line, Printer, Text, Row, render } from 'react-thermal-printer';
import { useStyle } from './style';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { resetData } from '../../hooks/printPdf/thermalData';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { setSnackbar } from '../../hooks/snackBar/reducers';

const CashCloseThermalPrint = () => {
    const data = useSelector(state => state.getThermalData)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const classes = useStyle()
    const [text, setText] = useState("Baby Corn 5 Kg")
    const [flag, setFlag] = useState(false)
    const [gst,setGst] = useState([])
    const [gData, setGData] = useState([])

    console.log('vanthuden', data)
    useEffect(()=>{
        if(data.onPress){
            console.log('vanthuden', data)
          if(data.getThermalData!==null ){
            // printableDiv.classList.add('printPDF')
            // printableDiv.classList.remove('printPDF')
            console.log(data.getThermalData.companyInfo.docno, 'Enna ithu')
            const docBill = data.getThermalData.companyInfo.docno
            console.log(docBill)
            const groupedData = _.groupBy(data.getThermalData.tableData,'cgstPerc')
            const result = _.map(groupedData,(val,tax)=>({
                cgstPerc : parseFloat(tax),
                gstAmt : _.sumBy(val, item=> parseFloat(item.cgstAmnt))
            }))
            // const groupData = _.groupBy(data.getThermalData.tableData, item => `${item.pro_name}_${item.hsn}_${item.mrp}_${item.sale_rate}_${item.cgstPerc}`)
            // console.log(groupData)
            // const getGroupData = _.map(groupData,(val,tax)=>({
            //     pro_name : val[0].pro_name,
            //     hsn : val[0].hsn,
            //     qty : _.sumBy(val, item=> parseFloat(item.qty)),
            //     sale_rate : val[0].sale_rate,
            //     mrp: val[0].mrp,
            //     totalAmt: _.sumBy(val, item=> parseFloat(item.totalAmt)),
            //     cgstAmnt : _.sumBy(val, item=> parseFloat(item.cgstAmnt)),
            //     cgstPerc: val[0].cgstPerc,
            //     disc1: val[0].disc1,
            //     // pur_rate: val[0].pur_rate,
            // }))
            // setGData(getGroupData)
            setGst(result)
         setFlag(true)
          }
        }
      
    },[data])
    useEffect(()=>{
      if(flag){
        window.print()
        dispatch(resetData())
        dispatch(setSnackbar(true,'success','Sales order processed successfully!'))
        navigate(-1)
        setFlag(false)
      }
    },[flag])
   
return(
<div>
{data.onPress && 
    <div style={{backgroundColor:'white', position : 'absolute', zIndex:1150, top:0,left : 0,  padding: 1}}>
<Printer type="epson" width={42}>
<Typography sx={{color:'black', textAlign : 'center', fontWeight: 600, fontSize:20}} textTransform="uppercase">GIRLUSH</Typography>
<Typography sx={{color:'black', textAlign : 'center', fontWeight: 600, fontSize:16}} >{data.getThermalData.companyInfo.acname}</Typography>
<Typography sx={{color:'black', textAlign : 'center', fontWeight: 600, fontSize:16}} textTransform="uppercase">{data.getThermalData.companyInfo.fullname}</Typography>
{/* <Typography sx={{color:'black', textAlign : 'center', fontWeight: 600, fontSize:14}}>{data.getThermalData.companyInfo.outlet_acname}</Typography>
<Typography sx={{color:'black', textAlign : 'center', fontWeight: 600, fontSize:14}}>{data.getThermalData.companyInfo.outlet_fullname}</Typography> */}
<Typography sx={{ color:'black',textAlign : 'center',  textWrap:'wrap', fontSize:13, fontWeight:"bold"}}>{data.getThermalData.companyInfo.add1}</Typography>
<Typography sx={{ color:'black',textAlign : 'center',  textWrap:'wrap', fontSize:13, fontWeight:"bold"}}>{data.getThermalData.companyInfo.add2} - {data.getThermalData.companyInfo.pincode}</Typography>
<Typography sx={{ color:'black',textAlign : 'center',  textWrap:'wrap', fontSize:13 , fontWeight:"bold"}}>Mobile : +91{data.getThermalData.companyInfo.mobile}</Typography>
<Typography fontWeight={600} sx={{ color:'black', textAlign : 'center',  textWrap:'wrap',  fontSize:13, fontWeight:"bold"}}>GSTIN - {data.getThermalData.companyInfo.gstin}</Typography>
{/* {data.getThermalData.companyInfo.outlet_type_name==='OTHERS' && <Typography sx={{ color:'black',textAlign : 'center', fontWeight: 660,fontSize:13}}>Bill of Supply</Typography>} */}

{/* <div style={{display : 'flex', justifyContent:'space-between', marginBlock: 1}}>
<Typography sx={{color:'black', fontWeight:600, fontSize: 10}}>Bill No : {data.getThermalData.companyInfo.docno}</Typography>
<Typography sx={{color:'black', fontWeight:600, fontSize: 10}}>Date : {moment(data.getThermalData.companyInfo.created_at).format('DD-MM-YYYY LT')}</Typography>
</div> */}
{/* <Text>--------------------------------------------</Text> */}
<Typography fontWeight={600} sx={{ color:'black', textAlign : 'left',  textWrap:'wrap',  fontSize:13,borderTop:"1px solid",borderBottom:"1px solid",marginBlock:.5,paddingTop:.5,paddingInline:1}}>Employee : {data.getThermalData.TotalData.employee}</Typography>
<Grid sx={{paddingInline:1}}>
        <div className='flex items-center justify-between'>
            <Typography sx={{fontWeight: 600, fontSize:13,width: "160px !important"}}>Date</Typography>
            <Typography >: </Typography>
            <Typography sx={{fontSize:13,width: "70px !important",textAlign:"right", fontWeight:"bold"}}>{data.getThermalData.TotalData.date}</Typography>
        </div>
        <div className='flex items-center justify-between'>
            <Typography sx={{fontWeight: 600, fontSize:13,width: "160px !important"}}>Total Sales</Typography>
            <Typography >: </Typography>
            <Typography sx={{fontSize:13,width: "70px !important",textAlign:"right", fontWeight:"bold"}}>{data.getThermalData.TotalData.totalSales}</Typography>
        </div>
        <div className='flex items-center justify-between'>
            <Typography sx={{fontWeight: 600, fontSize:13,width: "160px !important"}}>Cash Sales</Typography>
            <Typography >: </Typography>
            <Typography sx={{fontSize:13,width: "70px !important",textAlign:"right", fontWeight:"bold"}}>{data.getThermalData.TotalData.cashSales}</Typography>
        </div>
        <div className='flex items-center justify-between'>
            <Typography sx={{fontWeight: 600, fontSize:13,width: "160px !important"}}>Card Sales</Typography>
            <Typography >: </Typography>
            <Typography sx={{fontSize:13,width: "70px !important",textAlign:"right", fontWeight:"bold"}}>{data.getThermalData.TotalData.cardSales}</Typography>
        </div>
        <div className='flex items-center justify-between'>
            <Typography sx={{fontWeight: 600, fontSize:13,width: "160px !important"}}>Upi Sales</Typography>
            <Typography >: </Typography>
            <Typography sx={{fontSize:13,width: "70px !important",textAlign:"right", fontWeight:"bold"}}>{data.getThermalData.TotalData.upiSales}</Typography>
        </div>
        <div className='flex items-center justify-between'>
            <Typography sx={{fontWeight: 600, fontSize:13,width: "160px !important"}}>total No Of Invoice</Typography>
            <Typography >: </Typography>
            <Typography sx={{fontSize:13,width: "70px !important",textAlign:"right", fontWeight:"bold"}}>{data.getThermalData.TotalData.totalNoOfInvoice}</Typography>
        </div>
        <div className='flex items-center justify-between'>
            <Typography sx={{fontWeight: 600, fontSize:13,width: "160px !important"}}>Total Sales Return Amount</Typography>
            <Typography >: </Typography>
            <Typography sx={{fontSize:13,width: "70px !important",textAlign:"right", fontWeight:"bold"}}>{data.getThermalData.TotalData.totalSalesReturnAmount}</Typography>
        </div>
        <div className='flex items-center justify-between'>
            <Typography sx={{fontWeight: 600, fontSize:13,width: "160px !important"}}>SR Amount Used</Typography>
            <Typography >: </Typography>
            <Typography sx={{fontSize:13,width: "70px !important",textAlign:"right", fontWeight:"bold"}}>{data.getThermalData.TotalData.SRamountUser}</Typography>
        </div>
        <div className='flex items-center justify-between'>
            <Typography sx={{fontWeight: 600, fontSize:13,width: "160px !important"}}>Total Less Amount</Typography>
            <Typography >: </Typography>
            <Typography sx={{fontSize:13,width: "70px !important",textAlign:"right", fontWeight:"bold"}}>{data.getThermalData.TotalData.totalAmount}</Typography>
        </div>
        <div className='flex items-center justify-between'>
            <Typography sx={{fontWeight: 600, fontSize:13,width: "160px !important"}}>Total No Of Sales Return</Typography>
            <Typography >: </Typography>
            <Typography sx={{fontSize:13,width: "70px !important",textAlign:"right", fontWeight:"bold"}}>{data.getThermalData.TotalData.totalNoOfSalesReturn}</Typography>
        </div>
        <div className='flex items-center justify-between'>
            <Typography sx={{fontWeight: 600, fontSize:13,width: "160px !important"}}>Average of Bills</Typography>
            <Typography >: </Typography>
            <Typography sx={{fontSize:13,width: "70px !important",textAlign:"right", fontWeight:"bold"}}>{data.getThermalData.TotalData.averageofBills}</Typography>
        </div>
        <div className='flex items-center justify-between'>
            <Typography sx={{fontWeight: 600, fontSize:13,width: "160px !important",}}>Net Sales</Typography>
            <Typography >: </Typography>
            <Typography  sx={{fontSize:13,width: "70px !important",textAlign:"right" , fontWeight:"bold"} }>{data.getThermalData.TotalData.netSales}</Typography>
        </div>
    </Grid>
        <TableContainer sx={{paddingInline:1, width: '100%'}}>
            <Table sx={{ width: '100%'}}>
                <TableBody>
                    <TableRow>
                            {/* <TableCell padding='checkbox' className={classes.headCell} sx={{minWidth: 30}}>S.no</TableCell> */}
                            <TableCell className={classes.headCell} align='left' sx={{ width:30,fontWeight: 600, fontSize:12}}>Sno</TableCell>
                            <TableCell className={classes.headCell} align='center' sx={{width:60, fontWeight: 600}}>Denomination</TableCell>
                            <TableCell className={classes.headCell} align='center'  sx={{width:60, fontWeight: 600}}>Count</TableCell>
                            <TableCell className={classes.headCell} align='right'  sx={{width:65, fontWeight: 600}}>Amoint</TableCell>
                        </TableRow>
                            {_.map(data.getThermalData.tableData,(val,idx)=>(
                                <TableRow key={idx} className={classes.tblRowCell}>
                                <TableCell  align='left' sx={{fontWeight:"bold"}}>{idx + 1}</TableCell>
                                <TableCell align='center' sx={{fontWeight:"bold"}}>{parseFloat(val.denomination).toFixed(2)}</TableCell>
                                <TableCell align='center'sx={{fontWeight:"bold"}}>{val.count}</TableCell>
                                <TableCell align='right' sx={{fontWeight:"bold"}}>{val.total}</TableCell>
                                </TableRow> 
                            ))}
                        <TableRow>
                        <TableCell className={classes.headCell} colSpan={2}/>
                        <TableCell className={classes.headCell} colSpan={1} align='left'  sx={{ color:'black', fontSize : 12,fontWeight : 600,}}> Grand Total </TableCell>
                        <TableCell className={classes.headCell}  align='right' sx={{fontWeight : 600, color:'black', fontSize : 17}}>{data.getThermalData.TotalData.tot}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
   
{/* {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' &&
<TableContainer sx={{padding:1, color: 'black',}}>
    <Table>
        <TableHead >
           <TableRow >
           <TableCell className={classes.headCell}>Tax %</TableCell>
            <TableCell align='center'sx={{color:'black'}} className={classes.headCell}>CGST</TableCell>
            <TableCell align='center'sx={{color:'black'}} className={classes.headCell}>SGST</TableCell>
            <TableCell align='right'sx={{color:'black'}} className={classes.headCell}>Total</TableCell>
           </TableRow>
        </TableHead>
        <TableBody>
        {_.map(gst,(val,idx)=>(
            <TableRow className={classes.tblRowCell} key={idx}>
                <TableCell sx={{color:'black'}}>{parseFloat(val.cgstPerc).toFixed(2)}</TableCell>
                <TableCell sx={{color:'black'}} align='right'>{parseFloat(val.gstAmt / 2).toFixed(2)}</TableCell>
                <TableCell sx={{color:'black'}}align='right'>{parseFloat(val.gstAmt / 2).toFixed(2)}</TableCell>
                <TableCell sx={{color:'black'}}align='right'>{parseFloat(val.gstAmt).toFixed(2)}</TableCell>
            </TableRow>
        ))}
        <TableRow className={classes.tblSubCell}>
            <TableCell className={classes.headCell}>Total</TableCell>
            <TableCell align='right' className={classes.headCell}>{parseFloat(data.getThermalData.tableData.reduce((accumulator, currentValue) =>accumulator + Number(currentValue.cgstAmnt), 0)).toFixed(2) / 2}</TableCell>
            <TableCell align='right' className={classes.headCell}>{parseFloat(data.getThermalData.tableData.reduce((accumulator, currentValue) =>accumulator + Number(currentValue.cgstAmnt), 0)).toFixed(2) / 2}</TableCell>
            <TableCell align='right' className={classes.headCell}>{parseFloat(data.getThermalData.tableData.reduce((accumulator, currentValue) =>accumulator + Number(currentValue.cgstAmnt), 0)).toFixed(2)}</TableCell>
        </TableRow>
        </TableBody>
    </Table>
</TableContainer>
} */}
{/* {data.getThermalData.companyInfo.outlet_type_name=='OTHERS' && <Divider sx={{ backgroundColor:'black', margin:1}}/> } */}
{/* <Fragment>
{data.getThermalData.companyInfo.outlet_type_name=='OTHERS' && <Typography fontWeight={600} width={300} align='center' flexWrap='wrap' sx={{color:'black'}}>Composition Dealer: Not eligible to collect tax on supplies</Typography> }
<Typography  fontWeight={600} fontSize={12} marginLeft={2} sx={{color:'black'}}>Terms and Condition:</Typography>
<Typography  fontWeight={600} fontSize={12} marginLeft={2} sx={{color:'black'}}>*Goods received in good condition.</Typography>
<Typography  fontWeight={600} fontSize={12} marginLeft={2} sx={{color:'black'}}>*No exchange and No Return</Typography>
</Fragment> */}

{/* <Typography textAlign='center'fontWeight={600} sx={{color:'black', fontSize: 13}}>Order Online: www.buygirlush.com</Typography> */}
<Typography textAlign='center'fontWeight={600} sx={{ color:'black',fontSize: 13,marginBlock:1}}>***  THANK YOU! VISIT AGAIN ***</Typography>
<Cut />

</Printer>
</div>}
</div>
)
}

export default memo(CashCloseThermalPrint)